import { render, staticRenderFns } from "./DownSection.vue?vue&type=template&id=3cc41d0c&scoped=true&"
import script from "./DownSection.vue?vue&type=script&lang=js&"
export * from "./DownSection.vue?vue&type=script&lang=js&"
import style0 from "./DownSection.vue?vue&type=style&index=0&id=3cc41d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc41d0c",
  null
  
)

export default component.exports